<template>
	<div class="template_wrap">
		<Header v-if="isShow" />
		<div class="banner" :style="'background-image:url('+model.bannerUrl+')'">
			<!-- <img :src="model.bannerUrl" /> -->
		</div>

		<div id="anchor-wrap" class="anchor-wrap" :class="[isfixTab?'anchor-fixed':'', !isShow?'anchor-fixed2':'']">
			<div class="anchor-inner">
				<ul>
					<li @click="changeAnchor(item.id)" :class="[anchorId==item.id?'active':'']"
						v-for="(item,index) in nameList">{{item.name}}</li>
				</ul>
<!--				<router-link :to="{ path: `/applyTry?id=${productId}` }" class="apply-btn">申请试用</router-link>-->
				<div v-if="model.applyTrialFlag==1" @click="toDown()" class="apply-btn">申请试用</div>
			</div>
		</div>

		<div class="content">
			<div class="content-list" v-for="(item,index) in list" :id='"list"+item.id' :data-nameflag="item.nameFlag"
				:data-id="item.id">
				<!--富文本  item.detailType=1  展示数据： item.content-->
				<div v-if="item.detailType==1">
					<div class="overview-wrap" v-if="item.richTextType==1">
						<div :class="[isfixTab?'paddingInner':'']" class="overview">
							<ColumnsWhite :item="item"/>
						</div>
					</div>
					<div class="overview" v-else>
						<ColumnsGray :item="item"/>
					</div>
				</div>
				<!--概述 detailType=2-->
				<div v-if="item.detailType==2">
					<div class="overview-wrap">
						<div :class="[isfixTab?'paddingInner':'']" class="overview">
							<div class="overview-l">
								<img :src="item.detailUrl" />
							</div>
							<div class="overview-r">
								<h2>{{item.detailTitle}}</h2>
								<div class="overview-txt">
									<p v-html="item.content"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--操作系统-->
				<div v-if="item.detailType==3">
					<templateSystem :item="item"></templateSystem>
				</div>
				<!--成功案例-->
				<div v-if="item.detailType==4">
					<div class="case-wrap">
						<div class="h2-title-wrap" v-if="item.titleFlag==1">
							<h2 class="h2-title">
								<span>{{item.detailTitle}}</span>
							</h2>
						</div>
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="item3 in item.list">
									<div class="case">
										<div class="case-l">
											<img :src="item3.picUrl" />
										</div>
										<div class="case-r">
											<!-- <div class="txt1">教育</div> -->
											<h3>{{item3.title}}</h3>
											<div class="txt2 lineclamp3">
												{{item3.introduction}}
											</div>
											<a class="link" :href="item3.webUrl" target="_blank">
												<span class="text">了解更多</span>
												<span class="el-icon-right"></span>
											</a>
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>

					</div>
				</div>
				<!--产品-->
				<div v-if="item.detailType==5">
					<templateProduct :item="item"></templateProduct>
				</div>
				<!--相关资源-->
				<div v-if="item.detailType==6">
					<templateResource :item="item"></templateResource>
				</div>
				<!--分类+富文本格式-->
				<div v-if="item.detailType==7">
					<templateTxt :item="item"></templateTxt>
				</div>

			</div>


		</div>
		<Footer />
	</div>

</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	import Swiper from "swiper"
	import 'swiper/dist/css/swiper.css'
	import Header from '@/components/header'
	import Footer from '@/components/footer'
	import templateProduct from '@/components/product/template/productTab'
	import templateSystem from '@/components/product/template/systemTab'
	import templateResource from '@/components/product/template/resourceTab'
	import templateTxt from '@/components/product/template/txtTab'
	import ColumnsWhite from '@/components/product/template/columnsWhite'
	import ColumnsGray from '@/components/product/template/columnsGray'
	export default {
		name: 'TemplateProduct',
		components: {
			Header,
			Footer,
			templateProduct,
			templateSystem,
			templateResource,
			templateTxt,
			ColumnsWhite,
			ColumnsGray
		},
		data() {
			return {
				navId: '', //传过来的栏目id
				productId: '', //传过来的Id
				model: {},
				nameList: [], //标题名称
				list: [], //数据
				caseList: [],
				isfixTab: false,
				anchorId: '',
				userId: '',
				isShow: true,
				topUrl: '' //申请试用
			}
		},
		watch: {
			//路径改变重新刷新数据
			$route(to, from) {
				let productId = this.$route.params.id
				let navId = this.$route.params.navId
				this.productId = productId
				this.navId = navId
				this.getProductInfo()
				setTimeout(res => {
					this.initSwiper()
				}, 300)
			}
		},
		mounted() {
			this.navTop = document.querySelector('#anchor-wrap').offsetTop
			window.addEventListener('scroll', this.handleTabFix, true)
		},
		//离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
		beforeRouteLeave(to, from, next) {
			window.removeEventListener('scroll', this.handleTabFix, true)
			next()
		},
		created() {
			this.userId = localStorage.getItem('userId') || ''
			let productId = this.$route.params.id
			let navId = this.$route.params.navId
			this.productId = productId
			this.navId = navId
			this.getProductInfo()
			setTimeout(res => {
				this.initSwiper()
			}, 300)
		},
		methods: {
      toDown() {
        window.open(this.topUrl?this.topUrl:'https://www.kylinos.cn/support/trial.html')
      },
			changeAnchor(id) {
				this.anchorId = id
				window.location.href = '#list' + id
			},
			initSwiper() {
				new Swiper(".swiper-container", {
					autoplay: 5000,
					autoplayDisableOnInteraction: false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable: true,
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev'
				})
			},
			handleTabFix() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				var offsetTop = document.querySelector('#anchor-wrap').offsetTop
				scrollTop > 250 ? this.isfixTab = true : this.isfixTab = false
				var sections = document.getElementsByClassName('content-list')
				if (sections.length > 0) {
					for (var i = 0; i < sections.length; i++) {
						let nameflag = sections[i].getAttribute('data-nameflag')
						let id = sections[i].getAttribute('data-id')
						if (nameflag == 1) {
							if(scrollTop>=sections[i].offsetTop+300){
								this.anchorId = id
							}
						}
					}
				}
				let contentTop4 = document.querySelector('#footer').offsetTop - 300
				if (scrollTop > 250 && scrollTop < contentTop4) {
					this.isShow = false
				} else {
					this.isShow = true
				}
			},
			//获取产品信息
			async getProductInfo() {
				let param = {
					productId: this.productId
				}
				ajaxParam(param)
				const res = await post('v1/product/productDetail', qs.stringify(param))
				if (res.data.code == 200) {
					this.model = res.data.entity
					this.list = res.data.list
					this.nameList = res.data.nameList
					if (this.model.productTitle) {
						document.title = this.model.productTitle
					}
					if(res.data.entity.topUrl){
						this.topUrl = res.data.entity.topUrl
					}
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.lineclamp3 {
		-webkit-line-clamp: 3;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.btns {
		display: inline-block;
		margin: 50px 10px 0;
		padding: 11px 28px;
		border: 2px solid #DE0515;
		background: transparent;
		color: #DE0515;
		border-radius: 50px;
	}

	.btns:hover {
		background: #DE0515;
		color: #fff;
	}

	.btns-wrap {
		display: flex;
		justify-content: center;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #bfbfbf;
	}

	.link {
		display: flex;
		align-items: center;
		color: #DE0515;

		.text {
			line-height: 1.625;
		}

		.el-icon-right {
			font-size: 22px;
		}
	}

	.banner {
		width: 100%;
		height: 380px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		margin-left: auto;
		margin-right: auto;

		img {
			width: 100%;
			//max-height: 360px;
			height: 420px
		}
	}

	.anchor-wrap {
		position: relative;
		top: -25px
	}

	.anchor-fixed {
		position: fixed !important;
		top: 58px !important;
		left: 0;
		right: 0;
		z-index: 9;
		//animation: 0.2s test ease-in;
	}

	.anchor-fixed2 {
		position: fixed !important;
		top: 0px !important;
		left: 0;
		right: 0;
		z-index: 9;
		//animation: 0.2s test ease-in;
	}

	@keyframes test {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.anchor-inner {
		width: 1180px;
		height: 52px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;
		margin: 0px auto 0;
		padding: 0 30px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0px 7px 14px 2px rgba(0, 15, 79, 0.05);
		position: relative;
		box-sizing: border-box;
		z-index: 1;

		ul {
			flex: 1;
			display: flex;
			font-size: 16px;

			li {
				margin-right: 30px;
				cursor: pointer;
			}

			li.active {
				color: #DE0515;
			}
		}

		.apply-btn {
			display: block;
			margin: 10px 10px;
			padding: 6px 15px;
			background: #DE0515;
			border-radius: 50px;
			color: #fff;
			font-size: 15px;
			cursor: pointer
		}
	}

	.content {
		position: relative;
		top: -40px;
	}

	.content-list {
		margin-bottom: 20px;
		padding-left: 20px;
		padding-right: 20px;
	}

	.overview-wrap {
		background: #fff;
		padding-left: 20px;
		padding-right: 20px;

		.overview {
			display:flex;
			justify-content: space-between;
			width: 1140px;
			margin: 0 auto;
			//padding: 100px 0 65px;
			padding: 40px 0;

			.overview-l {
				width: 32%;

				img {
					width: 100%;
				}
			}

			.overview-r {
				flex: 1;
				padding-left: 60px;

				h2 {
					font-size: 34px;
					line-height: 1.55;
				}

				.overview-txt {
					font-size: 16px;
					line-height: 1.95;
					color: #666;

					p {
						padding-top: 23px;
					}
				}
			}
		}

		.paddingInner {
			padding-top: 50px;
			padding-bottom: 50px;
		}
	}



	.h2-title-wrap {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		width: 1180px;
		margin: 0 auto;

		.h2-title {
			width: 31%;
			font-size: 34px;

			span {
				position: relative;
				display: inline-block;
				margin-bottom: 15px;
			}

			span:after {
				content: '';
				height: 2px;
				position: absolute;
				left: 0;
				background-color: #DE0515;
				width: 50%;
				display: inline-block;
				bottom: -14px;
			}
		}

		.description {
			width: 61%;
			margin-bottom: 25px;
			font-size: 16px;
			line-height: 1.889;
			color: #666;
		}
	}

	.case-wrap {
		width: 1180px;
		margin: 0 auto;
		//padding-top: 110px;
		padding-top: 50px;

		.case {
			display: flex;
			justify-content: flex-end;
			margin-top: 40px;
			height: 380px;

			.case-l {
				width: 45%;
				box-sizing: border-box;
				position: absolute;
				left: 0;
				top: 50px;
				bottom: 50px;

				img {
					width: 100%;
					height: 100%;
					border-radius: 10px;
				}
			}

			.case-r {
				width: 61%;
				padding: 52px 60px 60px 120px;
				line-height: 1.95;
				background: #fff;
				border-radius: 10px;
				box-sizing: border-box;

				.txt1 {
					font-size: 18px;
					line-height: 1.58;
				}

				h3 {
					font-size: 26px;
					line-height: 1.6;
					margin-top: 5px;
				}

				.txt2 {
					font-size: 14px;
					line-height: 1.95;
					color: #666;
					margin-top: 15px;
					margin-bottom: 20px;
				}
			}
		}

		.swiper-pagination-fraction,
		.swiper-pagination-custom,
		.swiper-container-horizontal>.swiper-pagination-bullets {
			bottom: 10px
		}

		/deep/ .swiper-pagination-bullet-active {
			width: 20px !important;
			border-radius: 4px;
		}
	}
	// .overview-text{
	// 	width: 100%
	// }
	// .layout-txt2,
	// .layout-txt3 {
	// 	display: flex;
	// 	justify-content: flex-start;
	// 	box-sizing: border-box;

	// 	.layout-txt-list {
	// 		padding-right: 1%;
	// 		box-sizing: border-box;
	// 	}

	// 	.layout-txt-list:last-of-type {
	// 		padding-right: 0;
	// 	}
	// }
</style>
